var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRiskCalculator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5 0h7v8H5zm6 1H6v2h5zM7 4H6v1h1zM6 6h1v1H6zm3-2H8v1h1zM8 6h1v1H8zm3-2h-1v1h1zm-1 2h1v1h-1z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4h1.67l3 7h8.65L16 5l-.908-.418L12.68 10H5.33l-3-7H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 14.5a1.5 1.5 0 1 1-2.831-.691l.07-.121.093-.13.132-.144a1.5 1.5 0 0 1 .5-.316 1.5 1.5 0 0 1 .851-.063l.176.047q.168.06.315.152c.417.27.694.735.694 1.266m-1 0a.5.5 0 1 1-1 0 .5.5 0 1 1 1 0m6 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 1-1 0 .5.5 0 1 1 1 0",
  clipRule: "evenodd"
})));
export default SvgRiskCalculator;